// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';

export const resetProductDetails = () => ({
    type: actions.RESET_CLAIM_MCC_FOLLOWUP_PRODUCT_DETAILS
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/reset-product-details.js